import React, { ReactNode, useCallback } from "react"
import { ClassProps } from "../../utility/common/props"
import AsyncSearchableInput, { GetLabelFunction, OptionType } from "../AsyncSearchableInput/AsyncSearchableInput"
import { searchArticles } from "../../utility/knowledgeBase/articleSelect"
import { ValueType } from "react-select"
import { useTranslation } from "react-i18next"
import { Dispatch } from "../../utility/common/storeHelper"
import { AsyncProps } from "react-select/src/Async"

export const ARTICLE_OPTIONS_DEFAULT_PAGE_SIZE = 50

export interface ArticleSelectProps extends ClassProps {
    id: string
    name: string
    label?: string
    testId?: string
    disabled?: boolean
    projectId?: string
    searchBySymbolCode?: boolean
    allowSearchWithoutPermissions?: boolean
    allowNoSelectedOption?: boolean
    count?: number
    onSelect?: (option: ValueType<OptionType, false>) => void
    getLabel?: GetLabelFunction
    onChange?: (option: ValueType<OptionType, false>) => void
    onCustomInputChange?: <K, T>(name: string, value: K, initialValues: T) => void
    dispatch: Dispatch
    useValueForDefaultOptions?: boolean
    defaultOptions?: AsyncProps<OptionType>["defaultOptions"]
    defaultValue?: string
    icon?: ReactNode
    filter?: string[]
    placeholder?: string
    returnIdValue?: boolean
    returnOnlyScenarios?: boolean
    returnOnlyAnswers?: boolean
    isClearable?: boolean
}

const ArticleSelect: React.FC<ArticleSelectProps> = props => {
    const {
        className,
        id,
        name,
        label,
        testId,
        disabled,
        projectId,
        searchBySymbolCode,
        allowSearchWithoutPermissions,
        allowNoSelectedOption = false,
        count = ARTICLE_OPTIONS_DEFAULT_PAGE_SIZE,
        onSelect,
        getLabel,
        onChange,
        onCustomInputChange,
        dispatch,
        useValueForDefaultOptions,
        defaultOptions,
        defaultValue,
        icon,
        children,
        filter,
        placeholder,
        returnIdValue,
        returnOnlyAnswers,
        returnOnlyScenarios = false,
        isClearable = true
    } = props
    const { t } = useTranslation()

    const getIntentOptions = useCallback(
        searchArticles(
            dispatch,
            t,
            projectId,
            searchBySymbolCode,
            allowSearchWithoutPermissions,
            count,
            filter,
            returnIdValue,
            returnOnlyAnswers,
            returnOnlyScenarios,
            allowNoSelectedOption
        ),
        [dispatch, projectId]
    )
    return (
        <AsyncSearchableInput
            id={id}
            className={className}
            label={
                <>
                    {label}
                    {icon}
                </>
            }
            testId={testId}
            name={name}
            getOptions={getIntentOptions}
            isDisabled={disabled}
            onSelect={onSelect}
            getCustomLabel={getLabel}
            useValueForDefaultOptions={useValueForDefaultOptions}
            defaultOptions={defaultOptions}
            customDefaultValue={defaultValue}
            onChange={onChange}
            placeholder={placeholder}
            onCustomInputChange={onCustomInputChange}
            isClearable={isClearable}
        >
            {children}
        </AsyncSearchableInput>
    )
}

export default ArticleSelect
